var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('div',{staticClass:"buyer-item"},[(_vm.id && _vm.canAccess('supplier_buyer_details'))?_c('router-link',{attrs:{"to":{
        name: 'supplier_buyer_details',
        params: { supplierBuyerId: _vm.id },
      }}},[_vm._v(" "+_vm._s(_vm.onlyShowName ? _vm.name : _vm.id + ' - ' + _vm.name + " (" + _vm.buyerId + ")")+" ")]):_c('span',[_vm._v(_vm._s(_vm.onlyShowName ? _vm.name : _vm.id + ' - ' + _vm.name + " (" + _vm.buyerId + ")"))])],1):_c('div',[(_vm.id && _vm.canAccess('supplier_buyer_details'))?_c('router-link',{attrs:{"to":{
        name: 'supplier_buyer_details',
        params: { supplierBuyerId: _vm.id },
      }}},[_vm._v(" "+_vm._s(_vm.id)+" ")]):_c('span',[_vm._v(_vm._s(_vm.id))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }